import React from 'react';
import DaTable from './../../common/DaTable'
const numrows = 50;

class SystemLogContainer extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            url: '/admin/dashboard/system_log',
            data: [],
            last_id: 0,
            loading: false,
            limit: 50,
            offset: 0,
            datalen: 0,
            filters:
                [ true, true, true ],
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'log_id',
                        'type': 'primary',
                        'visible': false
                    },
                    {
                        'label' : 'Log Time',
                        'source' : 'log_time',
                        'type' : 'datetime'
                    },
                    {
                        'label' : 'Level',
                        'source' : 'level',
                        'type' : 'icon',
                        'values' : {
                            '0': 'INFO',
                            '1': 'WARNING',
                            '2': 'ERROR'
                        },
                        'classnames' : {
                            '0': 'label label-info',
                            '1': 'label label-warning',
                            '2': 'label label-danger'                        }
                    },
                    {
                        'label' : 'Source',
                        'source' : 'source',
                        'type' : 'enum',
                        'values' : {
                            'RADMOD' : 'Radius',
                            'CALLSHOP' : 'Callshop'
                        }
                    },
                    {
                        'label' : 'Type',
                        'source' : 'type',
                        'type' : 'enum',
                        'values' : {
                            'reg_reject' : "Reg. Reject",
                            'call_reject' : "Call Reject",
                            'routing_reject' : "Routing Reject",
                            'acct_start' : "Acct Start",
                            'acct_stop' : "Acct Stop",
                            'checkout_open' : "Checkout Open",
                            'checkout_close' : "Checkout Complete"
                        }
                    },
                    {
                        'label' : 'Message',
                        'source' : 'message',
                        'type' : 'text'
                    }
                ]
        }
    }
    componentDidMount(){
        this.refreshInterval = setInterval(() => {
            this.loadFromServer();
        }, 4000);
        this.loadFromServer();
    }
    loadFromServer() {
        var data = {'last_id' : this.state.last_id};
        var opt = {
            url: this.state.url,
            urlattrs: [],
            method: 'get',
        };
        var that = this;
        // $.when( execAjax(data, opt) ).done(function(data) {

        //     var last_id = that.state.last_id;
        //     var newdata = data.data.concat(that.state.data);

        //     var counts = [0,0,0];
        //     var total = 0;
        //     newdata.map(function(datarow, i) {
        //         if (datarow.log_id > last_id) {
        //             last_id = datarow.log_id;
        //         }
        //         if (that.state.filters[datarow.level] == true) {
        //             newdata[i].hidden = false;
        //         } else {
        //             newdata[i].hidden = true;
        //         }
        //         counts[datarow.level]++;
        //         total++;
        //         if (counts[datarow.level] > numrows) {
        //             newdata.splice(i, 1);
        //         }
        //         if (total > numrows) {
        //             newdata.splice(i, 1);
        //         }
        //     }, that);
        //     that.setState({
        //         data: newdata,
        //         last_id: last_id,
        //         loading: false
        //     });
        // }).fail(function(result) {
        //     that.setState({
        //         error: result.msg,
        //         loading: false
        //     });
        // });


    }

    componentWillUnmount() {
        clearInterval(this.refreshInterval);
    }
    toogleFilter(d) {
        var filter = this.state.filters;
        filter[d] = !this.state.filters[d];

        var newdata = [];
        this.state.data.map(function(datarow, i) {
            if (datarow.level == d) {
                datarow.hidden = !filter[d];
            }
            newdata.push(datarow);
        }, this);

        this.setState({
            filters: filter,
            data: newdata
        })
    }
    render() {

        var data = {
            data: this.state.data
        };

        return ( <div>
            <div className="row">
                <div className="col-md-12">
                    <h2>System Log</h2>
                </div>
            </div>
            <div className="panel panel-primary">
                <div className="panel-heading">
                    <div className="btn-group" data-toggle="buttons">
                        <label className="btn btn-danger active" onClick={this.toogleFilter.bind(this, '2')}>
                            <input type="checkbox" />
                                Errors
                        </label>
                        <label className="btn btn-warning active" onClick={this.toogleFilter.bind(this, '1')}>
                            <input type="checkbox" />
                                Warnings
                        </label>
                        <label className="btn btn-info active" onClick={this.toogleFilter.bind(this, '0')}>
                            <input type="checkbox" />
                                Info
                        </label>
                    </div>
                </div>
                <div className="panel-body with-table">
                    <DaTable
                        metadata={this.state.metadata}
                        data={ data }
                        loading = { this.state.loading }
                        noLoadMoreButton
                    />
                </div>
                <div className="panel-footer">
                    <p>For older entries click here</p>
                </div>
            </div>
        </div>)
    }
}

export default class extends React.Component{
    render() {
        return (
            <SystemLogContainer />
        )
    }
}